import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';

import HelpCategory from 'help/components/category';
import { fetchAllCategoriesIfNeeded, fetchCategoryArticlesIfNeeded } from 'help/ducks/categories';

HelpCategory.need = [
  fetchAllCategoriesIfNeeded,
  params => fetchCategoryArticlesIfNeeded(params.categorySlug)
];

export function mapStateToProps({ help: { categories } }) {
  return {
    ...categories
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const { categorySlug } = params;
  const actions = {
    fetchAllCategoriesIfNeeded,
    fetchArticles: partial(fetchCategoryArticlesIfNeeded, categorySlug),
  };

  return bindActionCreators(actions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelpCategory));



// WEBPACK FOOTER //
// ./help/containers/category.js